module.exports = __webpack_public_path__ + "media/onCancel.8a77e1fb.mp3";